module.exports = __webpack_public_path__ + "img/Steps to Retirement Infographic.76e2d180.png";